import InputField from './inputField';

export default class NumberField extends InputField {
  getType() {
    return 'number';
  }
}



/** WEBPACK FOOTER **
 ** ./app/components/forms/numberField.jsx
 **/